export default "__VITE_ASSET__1d12456d__"